enum FilterItemType {
	All = 'all',
	Apps = 'menuResults',
	Index = 'workflowFormResults'
}

export default FilterItemType;
